// Action types for the Agency Fulfilment Call Bot store module (STSMPD-1323).

export const AGENCY_CALL_STATE_SET = 'AGENCY_CALL_STATE_SET'
export const AGENCY_CALL_STATE_CLEAR = 'AGENCY_CALL_STATE_CLEAR'
// Fire-and-forget: hand a placed call off to the background tracking saga so its row pill keeps
// advancing to the terminal "Outcome" even after the modal is closed.
export const AGENCY_CALL_TRACK = 'AGENCY_CALL_TRACK'
